var openingHoursModule = angular.module('t2g.openingHours', [
  'gettext',
  'ui.router',
  require('t2g.common.services.notificationService').name,
  require('t2g.common.services.modelService').name,
]);

module.exports = openingHoursModule;

openingHoursModule.controller('OpeningHoursCtrl', require('./openingHoursCtrl'));
openingHoursModule.config(function($stateProvider) {
  $stateProvider.state('private.main.openingHours', {
    url: '/openingHours',
    title: 'Opening Hours',
    templateUrl: '/app/modules/openingHours/OpeningHoursView.html?v=4.5.6',
    controller: 'OpeningHoursCtrl',
    resolve: {
      officeResponse: function(OfficeDA) {
        return OfficeDA.get();
      },
    },
  });
});



// WEBPACK FOOTER //
// ./src/app/modules/openingHours/openingHoursModule.js